import { visit } from 'unist-util-visit';

/**
 * Remark plugin that transforms [text](popup) links into custom AST nodes
 * This allows ReactMarkdown to render custom popup link components
 */
export const remarkPopupPlugin = () => (tree: any) => {
  // Visit all link nodes in the AST (Abstract Syntax Tree)
  visit(tree, 'link', (node) => {
    // Check if the link URL is 'popup' (our custom protocol)
    if (node.url === 'popup') {
      // Transform the link node into a custom popup node
      node.type = 'popup';
      node.data = {
        hName: 'popup',
        hProperties: {
          linkText: node.children?.[0]?.value || 'View Terms',
        },
      };

      // Remove the url property since we don't need it anymore
      delete node.url;
    }
  });
};
